import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { AlertMessageModalConstant } from '../../../../constants/alert-message.constant';
import { closeModal } from '../../../../actions/app-modal.action';
import UtilService from '../../../../services/util.service';
import { setOtpFormValidated } from '../../../../actions/otp-modal.action';
import { validateOtp, generateOtp } from '../../../../actions/authorization.action';
import OtpModalService from '../../../../services/otp-modal.service';
import { checkRedirection } from '../../../../actions/dnd-app.action';

class OtpModal extends Component {

    closeModal = () => {
        this.props.closeModal();
        this.props.checkRedirection();
    }

    onClickHandler = () => {
        this.props.validateOtp();
    }

    checkNumberValidationWithLength = (event, length) => {
        UtilService.checkNumberValidationWithLength(event, length);
    }

    onChangeOtp = (event) => {
        const { setOtpFormValidated } = this.props;
        if (event && event.target && event.target.value) {
            const value = event.target.value;
            if (OtpModalService.validateEnteredOtp(value)) {
                const otp = { valid: true, value: value }
                setOtpFormValidated(otp);
            }
            else {
                const otp = { valid: false, value: '' }
                setOtpFormValidated(otp);
            }
        }
    }

    resendOtp = () => {
        this.props.generateOtp();
    }

    disableButton = () => {
        const { validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus, otpFormValidated } = this.props;
        return OtpModalService.disableButton(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus, otpFormValidated);
    }

    getButtonValue = () => {
        const { validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus } = this.props;
        return OtpModalService.getButtonValue(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus);
    }

    getOtpErrorMessage = () => {
        const {validateOtpApiResponse} = this.props
        return OtpModalService.getOtpErrorMessage(validateOtpApiResponse)
    }

    render() {
        const { modalTitle, invalidOtp, incorrectOtp, mobileNumber, incorrectResponse } = this.props;
        return (
            <Fragment>
                <div className="modal-header">
                    <h3 className="margin-top-0 ng-isolate-scope">{modalTitle}</h3>
                    <a className="close" href="javascript:void(0)" onClick={() => this.closeModal()}><i className="icon-outlined-cross"></i></a>
                </div>
                <div className="modal-body">
                    <form name="OtpForm" onSubmit={event => event.preventDefault()} noValidate>
                        <div className="form-group small mb-30">
                            <label className="field-title" data-i18n="mobile_number" module-id="common">Mobile Number</label>
                            <div className="input-group width-full">
                                <span className="input-group-addon fs-20 display-inline-block country_code">+91</span>
                                <input disabled={true} value={mobileNumber} className="width-full fs-20 " type="number" name="mobileNumber" required placeholder="Enter your number" autoComplete="off" />
                            </div>
                        </div>
                        {/* Enter OTP Section */}
                        <div className="form-group small mb-30">
                            <label className="text-uppercase">ONE TIME PASSWORD</label>
                            <div className="input-group mb-10">
                                <input className="otp-field-width otpfeild" onKeyPress={(event) => this.checkNumberValidationWithLength(event, 3)} onChange={this.onChangeOtp} autoComplete="off" required name="otp" type="number" />
                            </div>
                            <p className="message color-grey">Didn't receive OTP?<br /><span onClick={() => this.resendOtp()} className="cursor-pointer link">RESEND OTP</span></p>
                            {invalidOtp && <p className="small color-dark-orange pt-10">{AlertMessageModalConstant.INVALID_OTP}</p>}
                            {incorrectOtp && <p className="small color-dark-orange pt-10">{AlertMessageModalConstant.INCORRECT_OTP}</p>}
                            {incorrectResponse && <p className="small color-dark-orange pt-10">{this.getOtpErrorMessage()}</p>}

                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="action margin-top-20">
                        <button type="button" className="btn ng-isolate-scope" onClick={() => this.onClickHandler()} autoFocus="" disabled={this.disableButton()}>
                            {this.getButtonValue()}
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(closeModal()),
    setOtpFormValidated: (otp) => dispatch(setOtpFormValidated(otp)),
    validateOtp: () => dispatch(validateOtp()),
    generateOtp: () => dispatch(generateOtp()),
    checkRedirection: () => dispatch(checkRedirection())
})

const mapStateToProps = state => {
    return {
        modalName: state.modalInfo.activeModal.modalName,
        modalTitle: state.modalInfo.activeModal.modalTitle,
        validateOtpApiStatus: state.otpModalInfo.validateOtpApiStatus,
        validateOtpApiResponse: state.otpModalInfo.validateOtpApiResponse,
        authLoginApiStatus: state.otpModalInfo.authLoginApiStatus,
        otpFormValidated: state.otpModalInfo.otpFormValidated,
        mobileNumber: state.loginModalInfo.userId,
        invalidOtp: state.otpModalInfo.invalidOtp,
        incorrectOtp: state.otpModalInfo.incorrectOtp,
        incorrectResponse: state.otpModalInfo.incorrectResponse
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpModal);